
import { defineComponent } from "vue";
import { Entity } from "@/entities";
import { SearchEntitiesParams } from "@/services/entity-service";
import { entityService } from "@/services";
import {
  PaginatedTable,
  ColumnConfig,
  usePagination,
} from "@/components/common/tables";
import { mdiEye, mdiHomeCityOutline } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import { PagedAsyncIterDriver } from "@/pagination";

export default defineComponent({
  name: "EntityIndex",
  setup(_, ctx) {
    return {
      ...usePagination<Entity>(ctx.emit),
    };
  },
  data() {
    return {
      entities: [] as Entity[],
      entitySearchInput: "" as string,
      icon: mdiEye,
      icon2: mdiHomeCityOutline,
      entityTypes: {
        1: { name: "Institución", id: 1, checked: true },
        2: { name: "Municipio", id: 2, checked: true },
        3: { name: "Junta Comunal", id: 3, checked: true },
      },
      columnsConfig: [
        { propertyName: "acronym", title: "Acronimo" },
        { propertyName: "name", title: "Nombre" },
        { slotName: "type", title: "Tipo" },
        { slotName: "action", title: "" },
      ] as ColumnConfig[],
    };
  },
  async mounted() {
    await this.searchEntity();
  },
  methods: {
    async searchEntity() {
      const params: SearchEntitiesParams = {
        name_or_acronym: this.entitySearchInput,
      };
      const checkedTypesId = Object.values(this.entityTypes)
        .filter((e) => e.checked)
        .map((e) => e.id);
      if (checkedTypesId.length) {
        params.type_ids = checkedTypesId;
      }
      const iter = entityService.searchEntitiesAsync(params);
      this.setDriver(PagedAsyncIterDriver.fromAsyncIterable(iter));
      this.elements = [];

      await this.fetchData(1);
      this.currentPage = 1;
    },
    async onPaginationClick(payload: { pageClicked: number }) {
      await this.fetchData(payload.pageClicked);
      this.currentPage = payload.pageClicked;
    },
  },
  components: { SvgIcon, PaginatedTable },
});
